export default __webpack_public_path__ + "static/media/camera.d5565749.svg";